import {Input} from "../../../basic/input";
import {Label} from "../../../basic/label";
import {useTranslationWithKeys} from "../../../../hooks/useTranslationWithKeys";
import {type ProductData} from "../../../../types/product";

interface ProductFormProps {
    editedProductData: ProductData;
    onProductDataChange: (data: ProductData) => void;
}

export function ProductForm({editedProductData, onProductDataChange}: ProductFormProps) {
    const {t} = useTranslationWithKeys();

    return (
        <div className="grid md:grid-cols-2 gap-6">
            <div className="space-y-2">
                <Label htmlFor="productName">{t('admin.products.edit.form.name.label')}</Label>
                <Input
                    id="productName"
                    value={editedProductData.name || ""}
                    onChange={(e) => onProductDataChange({...editedProductData, name: e.target.value})}
                    placeholder={t('admin.products.edit.form.name.placeholder')}
                />
                <p className="text-muted-foreground">
                    {t('admin.products.edit.form.name.description')}
                </p>
            </div>

            <div className="space-y-2">
                <Label htmlFor="stripeProductId">{t('admin.products.edit.form.stripeId.label')}</Label>
                <Input
                    id="stripeProductId"
                    value={editedProductData.stripeProductId || ""}
                    onChange={(e) => onProductDataChange({
                        ...editedProductData,
                        stripeProductId: e.target.value
                    })}
                    placeholder={t('admin.products.edit.form.stripeId.placeholder')}
                />
                <p className="text-muted-foreground">
                    {t('admin.products.edit.form.stripeId.description')}
                </p>
            </div>

            <div className="space-y-2">
                <Label htmlFor="softwareDurationDays">{t('admin.products.edit.form.softwareDurationDays.label')}</Label>
                <Input
                    id="softwareDurationDays"
                    type="number"
                    value={editedProductData.softwareDurationDays || ''}
                    onChange={(e) => onProductDataChange({
                        ...editedProductData,
                        softwareDurationDays: e.target.value ? parseInt(e.target.value) : undefined
                    })}
                    placeholder={t('admin.products.edit.form.softwareDurationDays.placeholder')}
                />
                <p className="text-muted-foreground">
                    {t('admin.products.edit.form.softwareDurationDays.description')}
                </p>
            </div>

            <div className="space-y-2 md:col-span-2">
                <Label htmlFor="productDescription">{t('admin.products.edit.form.description.label')}</Label>
                <Input
                    id="productDescription"
                    value={editedProductData.description || ""}
                    onChange={(e) => onProductDataChange({
                        ...editedProductData,
                        description: e.target.value
                    })}
                    placeholder={t('admin.products.edit.form.description.placeholder')}
                />
                <p className="text-muted-foreground">
                    {t('admin.products.edit.form.description.description')}
                </p>
            </div>

            <div className="space-y-2">
                <Label htmlFor="productGroup">{t('admin.products.edit.group')}</Label>
                <Input
                    id="productGroup"
                    value={editedProductData.group || ""}
                    onChange={(e) => onProductDataChange({
                        ...editedProductData,
                        group: e.target.value || undefined
                    })}
                    placeholder={t('admin.products.edit.form.group.placeholder')}
                />
            </div>

            <div className="space-y-2">
                <Label htmlFor="productPriority">{t('admin.products.edit.priority')}</Label>
                <Input
                    id="productPriority"
                    type="number"
                    value={editedProductData.priority || ''}
                    onChange={(e) => onProductDataChange({
                        ...editedProductData,
                        priority: e.target.value ? parseInt(e.target.value) : undefined
                    })}
                    placeholder={t('admin.products.edit.form.priority.placeholder')}
                />
            </div>
        </div>
    );
}